import Vue from 'vue';
import '../scss/styles.scss';
import { RecipeCardItem } from '../models/RecipeCard';

export default Vue.extend({
	name: 'RecipeCard',
	props: ['recipeCard', 'creativeConfig', 'adCopy'],
	data() {
		return {
			currentHeadlineIndex: this.recipeCard.Description.length ? 0 : -1,
			header: this.recipeCard.Description
				? this.recipeCard.Description[0]
				: '',
			defaultAdCopy: '',
			defaultLogo:
				'https://secureimages.allrecipes.com/ar-images/ARlogoNew.svg',
			currentContent: '',
			currentContentIndex: -1,
			adArray: [],
		};
	},
	mounted() {
		this.start();
		this.header = this.recipeCard.Description[this.currentHeadlineIndex];
		this.setCurrentContent();
		setInterval(this.setCurrentContent, 1700);
	},
	methods: {
		start() {
			const vm = this;
			setInterval(() => {
				vm.currentHeadlineIndex += 1;
				if (
					vm.currentHeadlineIndex >= vm.recipeCard.Description.length
				) {
					vm.currentHeadlineIndex = 0;
				}
				if (vm.creativeConfig.template) {
					vm.header =
						vm.creativeConfig.template.adCopy ||
						vm.recipeCard.Description[vm.currentHeadlineIndex];
				}
			}, 4000);
		},
		buttonClicked() {
			if (!this.recipeCard.ClickThrough) {
				return;
			}
			this.$emit('actionBtnClicked', {
				url: this.recipeCard.ClickThrough,
			});
			window.open(this.recipeCard.ClickThrough, '_blank');
		},
		setCurrentContent() {
			this.adArray = this.adCopy
				? this.adCopy.split('|')
				: this.defaultAdCopy.split('|');
			if (!this.adArray.length) this.currentContent = '';
			this.currentContentIndex += 1;
			if (this.currentContentIndex > this.adArray.length) {
				this.currentContentIndex = 0;
			}
			const content: string = this.adArray[this.currentContentIndex];
			if (content && content.length) {
				this.currentContent = content.trim();
			}
		},
		recipeSiteLogo(){
			return `${this.creativeConfig.recipeSiteLogoFileUrl}300` || this.defaultLogo;
		},
		recipeCardImage(){
			return this.recipeCard.Image || `${this.creativeConfig.defaults.recipe.imageFileUrl}600`;
		},
		advertiserLogo(){
			return `${this.creativeConfig.advertiserLogoFileUrl}300` || this.recipeCard.Src;
		}
	},
	watch: {
		recipeCard: {
			// eslint-disable-next-line object-shorthand
			handler: function () {
				this.setCurrentContent();
			},
		},
		adCopy: {
			// eslint-disable-next-line object-shorthand
			handler: function () {
				this.setCurrentContent();
			},
		},
	},
	computed: {
		fontSize() {
			if (
				this.recipeCard.Title.length >= 1 &&
				this.recipeCard.Title.length < 18
			) {
				return 20;
			}
			if (
				this.recipeCard.Title.length >= 18 &&
				this.recipeCard.Title.length < 25
			) {
				return 15;
			}
			if (
				this.recipeCard.Title.length >= 25 &&
				this.recipeCard.Title.length < 35
			) {
				return 14;
			}
			if (
				this.recipeCard.Title.length >= 35 &&
				this.recipeCard.Title.length < 45
			) {
				return 13;
			}
			if (
				this.recipeCard.Title.length >= 45 &&
				this.recipeCard.Title.length < 55
			) {
				return 12;
			}
			if (
				this.recipeCard.Title.length >= 55 &&
				this.recipeCard.Title.length < 60
			) {
				return 11.5;
			}
			if (
				this.recipeCard.Title.length >= 60 &&
				this.recipeCard.Title.length < 75
			) {
				return 11;
			}
			if (
				this.recipeCard.Title.length >= 75 &&
				this.recipeCard.Title.length < 85
			) {
				return 10;
			}
			if (
				this.recipeCard.Title.length >= 85 &&
				this.recipeCard.Title.length < 100
			) {
				return 9;
			}
			if (
				this.recipeCard.Title.length >= 100 &&
				this.recipeCard.Title.length < 150
			) {
				return 8.5;
			}
			if (
				this.recipeCard.Title.length >= 150 &&
				this.recipeCard.Title.length < 200
			) {
				return 8;
			}
			return 10;
		},
	},
});
